var moduleMap = {
	"./Layout": function() {
		return __webpack_require__.e("src_views_layout_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/layout.vue */ "./src/views/layout.vue")); }; });
	},
	"./Background": function() {
		return __webpack_require__.e("src_views_background_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/background.vue */ "./src/views/background.vue")); }; });
	},
	"./Logo": function() {
		return __webpack_require__.e("src_views_logo_vue-_ebce1").then(function() { return function() { return (__webpack_require__(/*! ./src/views/logo.vue */ "./src/views/logo.vue")); }; });
	},
	"./Announcement": function() {
		return __webpack_require__.e("src_views_announcement_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/announcement.vue */ "./src/views/announcement.vue")); }; });
	},
	"./Notice": function() {
		return __webpack_require__.e("src_views_notice_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/notice.vue */ "./src/views/notice.vue")); }; });
	},
	"./CustomLink": function() {
		return __webpack_require__.e("src_views_customLink_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/customLink.vue */ "./src/views/customLink.vue")); }; });
	},
	"./Copyright": function() {
		return __webpack_require__.e("src_views_copyright_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/copyright.vue */ "./src/views/copyright.vue")); }; });
	},
	"./BrowserSupport": function() {
		return __webpack_require__.e("src_views_browserSupport_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/browserSupport.vue */ "./src/views/browserSupport.vue")); }; });
	},
	"./PasswordLogin": function() {
		return __webpack_require__.e("src_views_passwordLogin_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/passwordLogin.vue */ "./src/views/passwordLogin.vue")); }; });
	},
	"./SmsCodeLogin": function() {
		return __webpack_require__.e("src_views_smsCodeLogin_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/smsCodeLogin.vue */ "./src/views/smsCodeLogin.vue")); }; });
	},
	"./ScanLogin": function() {
		return __webpack_require__.e("src_views_scanLogin_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/scanLogin.vue */ "./src/views/scanLogin.vue")); }; });
	},
	"./FederatedLogin": function() {
		return __webpack_require__.e("src_views_federatedLogin_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/federatedLogin.vue */ "./src/views/federatedLogin.vue")); }; });
	},
	"./QuickLink": function() {
		return __webpack_require__.e("src_views_quickLink_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/quickLink.vue */ "./src/views/quickLink.vue")); }; });
	},
	"./NoticeBoard": function() {
		return __webpack_require__.e("src_views_noticeBoard_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/noticeBoard.vue */ "./src/views/noticeBoard.vue")); }; });
	},
	"./Language": function() {
		return __webpack_require__.e("src_views_language_vue").then(function() { return function() { return (__webpack_require__(/*! ./src/views/language.vue */ "./src/views/language.vue")); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});